// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"27a65fba","977":"9b7686ff"}[chunkId] + ".chunk.js";
};